<template>
  <div>
    <MobileDrawer :toggler="toggler" @click="toggler = !toggler" />
    <div class="admin-header">
      <div>
        <b-navbar-brand to="/dashboard" class="attach-media">
          <img alt="Route-line" class="logo" src="@/assets/logo.png" />
        </b-navbar-brand>
        <button class="hamberger" @click="toggler = !toggler">
          <i class="fa fa-bars"></i>
        </button>
      </div>
      <div class="d-flex">
        <!-- <router-link to="/dashboard" tag="div">
          <div class="user-profile">
            <img :src="imageUrl" v-if="imageUrl" class="profile-img" />
            <img
              src="../assets/userIcon.svg"
              v-else
              alt="Profile Images"
              class="profile-img"
            />
            <span class="name">
              {{
                user &&
                  (user.displayName
                    ? user.displayName.split(" ")[0]
                    : "" || user.displayName)
              }}
            </span>
          </div>
        </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Constant from "../modules/constants";
import { dbFs, getDownloadURL } from "../modules/database";
import store from "../modules/store";
import MobileDrawer from "@/components/MobileDrawer";

export default {
  data: () => ({
    plans: [],
    toggler: false,
    imageUrl: ""
  }),
  computed: {
    ...mapGetters({
      user: "getUser",
      planId: "getPlanId"
    }),
    getPlans() {
      return this.plans.filter(
        plan => plan.status === undefined || plan.status === true
      );
    }
  },
  mounted() {
    // this.firebaseReading();
    // this.getImageUrl();
  },
  methods: {
    async getImageUrl() {
      const url = this.user
        ? this.user.photoURL || Constant.profile.default_user_image
        : "";
      this.imageUrl = await getDownloadURL(url);
    },
    firebaseReading() {
      this.$bind(
        "plans",
        dbFs
          .collection("subscription")
          .where("assignedUsers", "array-contains", this.user.uid)
      );
    },
    handlePlanChange(e) {
      store.dispatch("updatePlanId", e.target.value);
    }
  },
  components: {
    MobileDrawer
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.toggler = false;
      }
    },
    plans() {
      if (this.plans.length > 0) {
        store.dispatch({
          type: "updatePlans",
          plans: this.plans
        });
      }
    }
  }
};
</script>

<style scoped>
.admin-header {
  display: flex;
  justify-content: space-between;
  padding: 15px 50px;
  background: var(--primary-color);
  align-items: center;
  height: 80px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--primary-color);
}
.logo {
  width: 160px;
}
.user-profile {
  padding: 5px 7px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 100px;
  cursor: pointer;
  min-width: 40px;
}
.name {
  opacity: 1 !important;
  color: black;
  padding-right: 12px;
}
.profile-img {
  width: 30px;
  height: 30px;
  border-radius: 20px;
  margin-right: 10px;
}
.dm-dropdown {
  border-radius: 20px;
  background: var(--white);
  padding: 2px 25px;
  outline: none;
  border: 1px solid var(--white);
  color: var(--secondary-color);
  margin-top: 5px;
  margin-right: 10px;
}
.hamberger {
  display: none !important;
  background: none;
  color: var(--secondary-color);
  border: none;
  outline: none;
  font-size: 22px;
}

@media screen and (max-width: 750px) {
  .name {
    display: none;
  }
  .attach-media {
    display: none;
  }
  .hamberger {
    display: inline !important;
  }
}
</style>
